"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var static_text_1 = require("../../../../components/pricing/text/static-text/static-text");

var constants_1 = require("../../../../theming/pricing-system/constants");

var textStyle = {
  fontStyle: 'italic'
};
var viewStyle = {
  marginBottom: '1rem',
  marginTop: '1rem'
};

exports.SelectGroupMessage = function () {
  return react_1.default.createElement(react_native_1.View, {
    style: viewStyle
  }, react_1.default.createElement(static_text_1.StaticText, {
    textStyle: textStyle,
    text: constants_1.SelectGroupMessageContent.message
  }));
};